module.exports = __webpack_public_path__ + "img/create-temp.d111471a.gif";